export const Text = {
  baseStyle: {},
}
